module.exports = __webpack_public_path__ + "img/RedteaSIM 3@2x.260ae857.png";